module.exports = __webpack_public_path__ + "static/media/m_eyeshape_hooded_hazel.0098b4df.png";